var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.2241 7.53076C13.2241 8.35919 12.5525 9.03076 11.7241 9.03076C10.8957 9.03076 10.2241 8.35919 10.2241 7.53076C10.2241 6.70233 10.8957 6.03076 11.7241 6.03076C12.5525 6.03076 13.2241 6.70233 13.2241 7.53076ZM11 10.0001C10.4477 10.0001 10 10.4478 10 11.0001C10 11.5524 10.4477 12.0001 11 12.0001V16.9992C11 17.5515 11.4477 17.9992 12 17.9992H13C13.5523 17.9992 14 17.5515 14 16.9992C14 16.4469 13.5523 15.9992 13 15.9992V11.0001C13 10.4478 12.5523 10.0001 12 10.0001H11Z",
    fill: "#0E75BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.88aac330493f54f0f697292ba3949dc9.svg";
export { ForwardRef as ReactComponent };